import fetch from "@/fetch";
// 获取数据词典列表
export const getSelectList = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/dropdownlist",
    data: params,
    actionTypeCode: "1",
    actionTypeDesc: "词典表常量获取",
  });
};

// 用户登出操作
export const logout = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/mine/logout",
    data: params,
    actionTypeCode: "2",
    actionTypeDesc: "用户登出",
  });
};

// 微信绑定
export const weChatBind = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/common/wechatbindprocess",
    data: params,
    loading: true,
    actionTypeCode: "3",
    actionTypeDesc: "微信绑定",
  });
};

// 通过微信code换openId
export const codeToOpenId = (params) => {
  return fetch({
    method: "post",
    url: "/common/wechat/auth",
    data: params,
    actionTypeCode: "4",
    actionTypeDesc: "微信code换取openId",
  });
};

// 通过code换取token及用户信息
export const codeToUserInfoGet = (params) => {
  return fetch({
    method: "post",
    url: "/oauth/login",
    data: params,
    actionTypeCode: "5",
    actionTypeDesc: "业务code换用户信息",
  });
};

// 获取第三方应用列表
export const thirdAppListGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/index/thirdapplist",
    data: params,
    actionTypeCode: "6",
    actionTypeDesc: "第三方应用获取",
  });
};
// 获取第三方授权
export const userAuth = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/thirdapp/userauth",
    data: params,
    loading: true,
    actionTypeCode: "7",
    actionTypeDesc: "第三方应用授权获取",
  });
};

// 文件id转base64
export const fileIdToBase64Get = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/index/imgbase64",
    data: params,
    actionTypeCode: "8",
    actionTypeDesc: "文件id转base64",
  });
};

// 通过文件ID获取文件URL
export const fileIdToUrlGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/index/getfile",
    data: params,
    actionTypeCode: "38",
    actionTypeDesc: "文件id转url",
  });
};

// 获取微信消息详情
export const getMessageDetail = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/getmessagedetail",
    data: params,
    actionTypeCode: "43",
    actionTypeDesc: "微信模板消息详情",
  });
};

// 查询当前用户捐赠的图书列表
export const getBookDonateList = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/activity/getbookdonatelist",
    data: params,
    actionTypeCode: "44",
    actionTypeDesc: "我的捐赠列表",
  });
};

// 用户积分权限查询
export const integralPermissionCheck = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/checkuserpermission",
    data: params,
    actionTypeCode: "53",
    actionTypeDesc: "用户是否有积分查看权限",
  });
};

// 用户访问权限查询
export const usertestRequirmentCheck = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/mine/usertestrequirment",
    data: params,
    actionTypeCode: "55",
    actionTypeDesc: "用户访问权限查询",
  });
};
